<template>
    <vue-custom-scrollbar>
        <table class="attivita table mb-0 card-body bg-white">
            <thead>
                <tr>
                    <th scope="col"></th>
                    <th
                        scope="col"
                        class="text-center text-blusbiadito px-1"
                    >
                        <font-awesome-icon
                            :icon="['fas', 'star']"
                            title="Preferiti degli utenti"
                        />
                    </th>
                    <th
                        scope="col"
                        class="text-center text-blusbiadito px-1"
                    >
                        <font-awesome-icon
                            :icon="['fas', 'shopping-cart']"
                            title="Prodotti nel carrello degli utenti"
                        />
                    </th>
                    <th
                        scope="col"
                        class="text-center text-blusbiadito px-1"
                    >
                        <font-awesome-icon
                            :icon="['fa', 'money-bill-alt']"
                            title="Ordini ricevuti"
                        />
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="event in events"
                    :key="event.eventId"
                >
                    <td>{{event.name}}</td>
                    <td class="text-center px-1">
                        <span
                            v-if="event.favorites > 0"
                            class="alert alert-info p-1"
                        >
                            <router-link :to="{ name: 'backend-reports-visitors', query: {eventId: event.eventId, filter: 'fav'} }">
                                {{ event.favorites }}
                            </router-link>
                        </span>
                        <font-awesome-icon
                            v-else
                            :icon="
                                    ['fas', 'minus'
                                    ]"
                            class="text-blurikorda"
                        />
                    </td>
                    <td class="text-center px-1">
                        <span
                            v-if="event.itemsInCart > 0"
                            class="alert alert-info p-1"
                        >
                            <router-link :to="{ name: 'backend-reports-visitors', query: {eventId: event.eventId, filter: 'cart'} }">
                                {{ event.itemsInCart }}
                            </router-link>
                        </span>
                        <font-awesome-icon
                            v-else
                            :icon="['fas', 'minus']"
                            class="text-blurikorda"
                        />
                    </td>
                    <td class="text-center px-1">
                        <span
                            v-if="event.orders>0"
                            class="alert alert-info p-1"
                        >
                            <router-link :to="{ name: 'backend-reports-visitors', query: {eventId: event.eventId, filter: 'order'} }">
                                {{ event.orders }}
                            </router-link>
                        </span>
                        <font-awesome-icon
                            v-else
                            :icon="['fas', 'minus']"
                            class="text-blurikorda"
                        />
                    </td>
                </tr>
                <tr>
                    <td
                        colspan="4"
                        class="text-center px-1"
                    >
                        <a
                            href="#"
                            @click="goToViewAll"
                        >{{ $t('Vedi tutte') }}</a>
                    </td>
                </tr>
            </tbody>
        </table>
    </vue-custom-scrollbar>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
    name: "BackendDashboardBoxRecenti",
    props: ["events"],

    components: { vueCustomScrollbar },

    data() {
        return {};
    },

    methods: {
        goToViewAll() {
            this.$emit("viewAllClicked");
        }
    }
};
</script>

<style scoped>
section {
}

div.card-body {
    padding: 0;
}

section,
div.card-body {
    height: 100%;
}
</style>
